<jhi-alert></jhi-alert>
<jhi-bary-card>
  <div body>
    <jhi-bary-table-manager [type]="QUOTES" [service]="quotationsService" [tableOptions]="{ state: 'ONGOING' }"></jhi-bary-table-manager>
    <div class="d-flex alert alert-info align-items-center">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" size="2x" class="mr-1"></jhi-bary-icon>
      <span class="mr-2" jhiTranslate="baryApp.quotations.ongoing.user-text"></span>
      <jhi-bary-icon icon="ellipsis-vertical" [faDirective]="FAS" size="lg"></jhi-bary-icon>
    </div>
  </div>
</jhi-bary-card>
